import { defineStore } from 'pinia'
import { api } from '@/plugins/axios';
import { useLoaderStore } from '@/stores/loader';
import moment from 'moment';

export const useCommonStore = defineStore('common-store', {
  // State (if you need to store any date-related state)
  state: () => ({
    loaderVisible: false,
    categories: [],
    attributes: [],   
    productsOptions: [],
    stores: [],
  }),

  // Getters (computed properties)
  getters: {},

  // Actions (methods)
  actions: {
    async getCategories() {
      try {
        const response = await api.get(`get-categories`)                
        this.categories = response.data.results
      } catch (error) {
        console.error('Error fetching categories:', error)
      }
    },
    async getStores() {
      try {
        const response = await api.get(`get-stores`)                
        this.stores = response.data.results
      } catch (error) {
        console.error('Error fetching stores:', error)
      }
    },
    async getProductsByCategory(categoryId) {
      const loader = useLoaderStore()
      try {
        loader.show('Loading products...')
        let url = `get-products`
        let filterArray = [{
          column: "category_id",
          value: categoryId,
          condition: "="
        }]
        url += `?filterArray=${JSON.stringify(filterArray)}`
        const response = await api.get(url)
        this.productsOptions = response.data.results
      } catch (error) {        
        console.error('Error fetching products:', error)
      } finally {
        loader.hide()
      }
    },
    async getAttributes() {
      try {
        const response = await api.get(`get-attributes`)                
        this.attributes = response.data.results
      } catch (error) {
        console.error('Error fetching attributes:', error)
      }
    },
    getStatusClass(status) {
      switch ((status || '').toLowerCase()) {
        case 'process':
          return 'bg-info'
        case 'layered':
          return 'bg-warning text-dark'
        case 'ready':
          return 'bg-primary'
        case 'delivered':
        case 'pickedup':
          return 'bg-success'
        case 'cancel':
          return 'bg-danger'
        case 'pending':
          return 'bg-secondary'
        default:
          return 'bg-light text-dark'
      }
    },
    formatDate(date){
      return moment(date).format('DD-MM-YYYY HH:mm')
    }
  }
});
